import { translate } from 'components/Translation';
import { HeadingS } from 'components/Typography/Typography';
import CanPerform from 'components/CanPerform/CanPerform';
import CustomButton from 'components/CustomButtons/Button';
import Add from '@material-ui/icons/Add';
import moment from 'moment';
import { AccountCell } from 'components/Cells/Cells';
import CustomAvatar from 'components/CustomAvatar/CustomAvatar';
import Badge from 'components/Badge/Badge';
import GridItem from 'components/Grid/GridItem';
import InfoCard from 'components/Info/InfoCard';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/detailsStyle';
import { makeStyles } from '@material-ui/core';
import Business from '@material-ui/icons/Business';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IPermissionsElementProps {
	isAdmin: boolean;
	handleClickAddPermission: () => void;
	handleClickEditPermission: (accountId: string) => void;
	canPerformAction: string;
	user: types.users.IExtendedCorpUserDetails;
}

const PermissionsElement = ({
	isAdmin,
	handleClickAddPermission,
	canPerformAction,
	handleClickEditPermission,
	user,
}: IPermissionsElementProps) => {
	const classes = useStyles();
	let elements: types.users.IPermission[] = [];
	const departmentPermissions = user.permissions.filter((permission) => permission.type !== 'B');

	const header = [isAdmin ? translate('organizations') : translate('departments'), translate('access.expDate')];

	const emptyElements = (
		<div className={classes.emptyElementsContainer}>
			<HeadingS color="disabled-light">{translate('users.details.noPermissions')}</HeadingS>
			<CanPerform
				action={canPerformAction}
				yes={
					<CustomButton color="tertiary-light" className={classes.button} onClick={handleClickAddPermission}>
						<>
							<Add /> {translate('users.details.addPermissions')}
						</>
					</CustomButton>
				}
			/>
		</div>
	);

	const isUnlimited = (permission: any): string =>
		!permission.permissionExpiration
			? translate('unlimited')
			: moment(permission.permissionExpiration).format('DD.MM.YYYY');

	if (departmentPermissions && departmentPermissions.length > 0) {
		if (isAdmin) {
			elements = departmentPermissions.map((permission) => ({
				title: (
					<AccountCell
						icon={
							<CustomAvatar
								placeholderIcon={<Business />}
								customClasses={classes.inlineIcon}
								accountId={permission.accountId}
							/>
						}
						text={permission.accountName || ''}
					/>
				),
				value: isUnlimited(permission),
				isTitleObject: true,
			}));
		} else {
			// manager
			elements = departmentPermissions.map((permission) => ({
				title: (
					<Badge filled hexColor={permission.departmentUiColor}>
						{permission.departmentName}
					</Badge>
				),
				value: isUnlimited(permission),
				isTitleObject: true,
			}));
		}
	}

	return (
		<GridItem xs={12} md={6} className={classes.infoCardGrid}>
			<InfoCard
				buttons={[
					departmentPermissions && {
						label: translate('edit'),
						onClick: () => handleClickEditPermission(user.userData.accountId),
					},
				].filter(Boolean)}
				rowsHeader={header}
				emptyElementsComponent={emptyElements}
				elements={elements}
				title={translate('department.permissions')}
				action={canPerformAction}
			/>
		</GridItem>
	);
};

export default PermissionsElement;
